import React from 'react';
import { GridCheckboxCell } from './GridCheckboxCell';
export function gridCheckboxCell(config) {
    return function textCellRenderer(_a) {
        var column = _a.column, rowIndex = _a.rowIndex, cellIndex = _a.cellIndex;
        var _b;
        return (React.createElement(GridCheckboxCell, { onClick: function () { return config.onClick(rowIndex); }, checked: config.isChecked(rowIndex), disabled: (_b = config.isDisabled) === null || _b === void 0 ? void 0 : _b.call(config, rowIndex), key: "checkbox-cell-" + rowIndex + "-" + cellIndex + "-" + column.id }));
    };
}
//# sourceMappingURL=cell.js.map